import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    const role = sessionStorage.getItem("pending_role") || "buyer";
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sid, role });
        setUser(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(data.user.role === "seller" ? "/dashboard" : "/catalog", { replace: true });
      } catch {
        navigate("/auth", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return <div className="min-h-screen grid place-items-center text-stone-500">Connexion en cours…</div>;
}
